import { useCallback } from 'react'
import { KEY_CODE } from '../common/src/helpers/keyboardHelper'
import { useHotkey, isSearchHotKey } from './useHotkey'

export const useSearchKeyPress = onSearchKeyPress => {
  const eventChecker = useCallback(evt => isSearchHotKey(evt) || evt.keyCode === KEY_CODE.F3, [])
  useHotkey(eventChecker, onSearchKeyPress)
}
